import React from 'react'

const LinkWithParagraph = ({ Link, Content }) => (
    <p>
        <a target="_blank" rel="noreferrer" href={Link}> {Content} </a>
    </p>
)

export default LinkWithParagraph